import { useTranslation } from "react-i18next";
import CustomerPageLayout from "../../customer-page-layout/CustomerPageLayout";
import { useTenant } from "../../../../tenant/branding/useTenant";
import styles from "./AppInformationPage.module.scss";
import packageJson from "../../../../../package.json";
import { TenantLogo } from "../../../../tenant/branding/TenantLogo";
import LoadedImage from "../../../../common/components/loaded-image/LoadedImage";

export const APP_VERSION = packageJson.version;

export const AppInformationPage = () => {
	const { t } = useTranslation();
	const { logo, appInfoText, poweredBy } = useTenant();
	return (
		<CustomerPageLayout title={t("account.appInformation")} showBackButton>
			<div className={styles.page}>
				<div className={styles.body}>
					<LoadedImage src={logo} alt={t("account.web.appLogoAlt")} className={styles.logo} />
					{appInfoText && <TenantLogo logo={appInfoText} alt="" className={styles.infoText} />}
				</div>

				<div className={styles.bottomBar}>
					<p className={styles.version}>{t("account.version")} {APP_VERSION}</p>
					<hr className={styles.divider} />
					{poweredBy && (
						<div className={styles.poweredByRow}>
							<span className={styles.poweredByLabel}>{t("common.labels.poweredBy")}</span>
							<span className={styles.vSeparator} />
							<TenantLogo logo={poweredBy.logo} alt={poweredBy.name}  />
							{/* <span className={styles.mycronLabel}>{poweredBy.name}</span> */}
						</div>
					)}
					<hr className={styles.divider} />
					<div className={styles.copyright}>
						<span>{t("account.copyright", { year: new Date().getFullYear() })}</span>
						<span>{t("account.allRightsReserved")}</span>
					</div>
				</div>
			</div>
		</CustomerPageLayout>
	);
};
